<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
                  <b-navbar-nav>
            <b-button @click="previousDailyVehicleTrackView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>TPT Dashboard</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form> </b-nav-form>
          </b-navbar-nav> -->
        </b-navbar>

        <!-- User Interface controls -->
        <!-- <div>
          <b-form-group>
            <b-input-group>
              <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div> -->
        <b-card>
          <b-row>
            <b-col md="3">
              <date-range-picker
                class="mb-1"
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
              > </date-range-picker>
              <span><b>Total Available : </b> <b>{{TotaAvilableVehicle}}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;
              <span><b>Total Booked : </b> <b>{{TotaBookedVehicle}}</b></span>
            </b-col>
            <b-col md="9">
              <model-list-select
                :list="clientMaster"
                id="clientNamenew"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
            </b-col>
          </b-row>
          <div>
            <b-row>
              <b-col md="9">
                <div style="width:100%;text-align:center">
                  <b-button
                    size="sm"
                    class="ml-auto"
                    @click="filterSearch"
                    variant="outline-primary"
                    >Search</b-button
                  >
    
                  <b-button
                    size="sm"
                    class="ml-3"
                    @click="clearFilter"
                    variant="outline-info"
                    >clear</b-button
                  >
                  <!-- <b-button
                    size="sm"
                    class="ml-3"
                    @click="getReportsAss('TPTDashbord_SCREEN')"
                    variant="outline-info"
                    >Export as Excel</b-button
                  > -->
                  <b-button
                    class="ml-3"
                    :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                    @click="getReportsAss('TPTDashbord_SCREEN','Export as Excel')"
                    size="sm"
                    variant="outline-info"
                    > {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export as Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>
                </div>
              </b-col>
              <b-col md="3">
                <b-button
                  size="sm"
                  class="ml-auto"
                  @click="DailyVehicleTrack"
                  variant="outline-primary"
                  >Daily Vehicle Tracking Status</b-button
                >
                
                <!-- <b-button
                  style="margin-top: 40px"
                  size="sm"
                  class="ml-3"
                  @click="getReportsAss('MainAssignment_All_Summary_SCREEN')"
                  variant="outline-info"
                  >Export as All Summary Excel</b-button
                > -->
              </b-col>
            </b-row>
          </div>
        </b-card>
        <div>
            <h5 class="text-muted pull-right mt-2 ml-3">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>

          <!-- Main table element -->
        <div class="table-responsive tableMain mt-3">
          <b-table
            show-empty
            stacked="md"
            :items="veiwVehicleMaster"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="sr_no" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="regdNo" slot-scope="row1">
              <b>{{ row1.item.regdNo }}</b>
            </template>
            <template slot="isTruckMasterActive" slot-scope="row2">
              <h6
                v-if="
                  row2.item.isTruckMasterActive == '1' &&
                  row2.item.vehicleActiveInactiveId == '1'
                "
              >
                <b-badge variant="success">Available</b-badge>
              </h6>
              <h6
                v-if="
                  row2.item.isTruckMasterActive == '0' &&
                  row2.item.vehicleActiveInactiveId == '1'
                "
              >
                <b-badge variant="danger">Booked</b-badge>
              </h6>
              <h6 v-if="row2.item.vehicleActiveInactiveId == '2'">
                <b-badge variant="dark">INACTIVE</b-badge>
              </h6>
            </template>

            <!-- <template slot="engineNo" slot-scope="row3">
                {{ row3.item.engineNo }}
              </template>
              <template slot="chassisNo" slot-scope="row4">
                {{ row4.item.chassisNo }}
              </template>
              <template slot="modNo" slot-scope="row4">
                {{ row4.item.modNo }}
              </template> -->
            <template slot="TripCount" slot-scope="row4">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="showToTTrip(row4.item)"
                >{{ row4.item.TripCount }}
              </b-button>
            </template>
          </b-table>
        </div>
        <!-- Added By Priyanshu SIngh STart -->
        <b-modal
          no-close-on-esc
          no-close-on-backdrop
          size="xl"
          ref="Trip-modal"
          hide-footer
          title="Trip Details"
        >
          <!-- <div class="d-block text-center">
            <h3>Trip Details</h3>
          </div> -->
          <b-row>
            <b-col cols="12">
              <div class="table-responsive tableMain mt-3" v-if="TripDetails.length > 0">
                <b-table
                  show-empty
                  stacked="md"
                  :items="TripDetails"
                  :fields="TripCount"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                >
                  <template slot="sr_no" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="Vehicle_NO" slot-scope="row1">
                    <b>{{ row1.item.Vehicle_NO }}</b>
                  </template>
                  <template slot="mainSalesSeries" slot-scope="row2">
                    <span>{{ row2.item.mainSalesSeries }}</span>
                    <h6
                      v-if="
                        row2.item.isTruckMasterActive == '1' &&
                        row2.item.vehicleActiveInactiveId == '1'
                      "
                    >
                      <b-badge variant="success">Available</b-badge>
                    </h6>
                    <h6
                      v-if="
                        row2.item.isTruckMasterActive == '0' &&
                        row2.item.vehicleActiveInactiveId == '1'
                      "
                    >
                      <b-badge variant="danger">Booked</b-badge>
                    </h6>
                    <h6 v-if="row2.item.vehicleActiveInactiveId == '2'">
                      <b-badge variant="dark">INACTIVE</b-badge>
                    </h6>
                  </template>
                  <template slot="clientName" slot-scope="row4">
                    <span>{{ row4.item.clientName }}</span>
                  </template>
                  <template slot="" slot-scope="row5">
                    <h6
                      v-if="
                        row5.item.status == '1'
                      "
                    >
                      <b-badge variant="success">Available</b-badge>
                    </h6>
                    <h6
                      v-if="
                        row5.item.status == '2'
                      "
                    >VehicleStatus
                      <b-badge variant="danger">Booked</b-badge>
                    </h6>
                  </template>
                  <template slot="status" slot-scope="row6">
                    <h6
                      v-if="
                      row6.item.status == '1'
                      "
                    >
                      <b-badge variant="success">Available</b-badge>
                    </h6>
                    <h6
                      v-if="
                      row6.item.status == '2'
                      "
                    >
                      <b-badge variant="danger">Booked</b-badge>
                    </h6>
                  </template>
                  <template slot="skipGRN" slot-scope="row7">
                    <b-button
                      v-if="row7.item.skipGRN == '0'"
                      size="sm"
                      variant="outline-success"
                      @click="Print(row7.item.pdfGRN)"
                      >GRN PDF</b-button
                    >
                  </template>
                  <template slot="tptType" slot-scope="row8">{{ (row8.item.tptType == 1)?'Pridel':'Outsourced' }}</template>
                  <template slot="distance" slot-scope="row9">{{ row9.item.distance }}</template>
                  <template slot="tollInCash" slot-scope="row10">{{ row10.item.tollInCash }}</template>
                  <template slot="otherCashExpenses" slot-scope="row11">{{ row11.item.otherCashExpenses }}</template>
                  <template slot="diesel" slot-scope="row12">{{ row12.item.diesel }}</template>
                  <template slot="dieselPrice" slot-scope="row13">{{ row13.item.dieselPrice }}</template>
                  <template slot="totalCost" slot-scope="row14">{{ row14.item.totalCost }}</template>
                  <template slot="cashDeiselPaid" slot-scope="row15">{{ row15.item.cashDeiselPaid }}</template>
                </b-table>
              </div>
              <!-- <table class="table table-sm table-bordered mt-2">
                <tbody style="background: white">
                  <tr v-if="TripDetails.length > 0">
                    <th scope="col" style="width: 5px">SN.</th>
                    <th scope="col" style="width: 600px">Vehical NO.</th>
                    <th scope="col" style="width: 600px">Assignment NO.</th>
                    <th scope="col" style="width: 600px">Client</th>
                    <th scope="col" style="width: 180px">Vehical Status</th>
                    <th scope="col" style="width: 180px">Status</th>
                    <th scope="col" style="width: 180px">PDF</th>
                    <th scope="col" style="width: 180px">TPT By</th>
                    <th scope="col" style="width: 180px">Distance</th>
                    <th scope="col" style="width: 180px">Advance Cash</th>
                    <th scope="col" style="width: 180px">Actual cash Dispensed</th>
                    <th scope="col" style="width: 180px">Diesel</th>
                    <th scope="col" style="width: 180px">Actual Diesel Dispensed</th>
                    <th scope="col" style="width: 180px">Toll in cash</th>
                    <th scope="col" style="width: 180px">Amount Paid in Cash for Diesel</th>
                    
                  </tr>
                  <tr v-for="(item, index) in TripDetails" :key="index">
                    <th scope="row">{{ index + 1 }}.</th>
                    <td>{{item.Vehical_NO}}</td>
                    <td>{{item.mainSalesSeries}}</td>
                    <td>{{item.clientName}}</td>
                    <td>
                      <h6 v-if="item.status == '1'"><b-badge variant="danger">Booked</b-badge></h6>
                      <h6 v-if="item.status == '2'"><b-badge variant="success">Available</b-badge></h6>
                    </td>
                    <td>
                      <h6 v-if="item.status == '1'"><b-badge variant="success">In-Transit</b-badge></h6>
                      <h6 v-if="item.status == '2'"><b-badge variant="danger">closed</b-badge></h6>
                    </td>
                    <td>
                      <b-button
                            v-if="item.skipGRN == '0'"
                            size="sm"
                            variant="outline-success"
                            @click="Print(item.pdfGRN)"
                            >GRN PDF</b-button
                          >
                    </td>
                    <td>{{(item.tptType == 1)?'Pridel':'Outsourced'}}</td>
                    <td>{{item.distance}}</td>
                    <td>{{item.tollInCash}}</td>
                    <td>{{item.otherCashExpenses}}</td>
                    <td>{{item.diesel}}</td>
                    <td>{{item.dieselPrice}}</td>
                    <td>{{item.totalCost}}</td>
                    <td>{{item.cashDeiselPaid}}</td>
                  </tr>
                </tbody>
              </table> -->
            </b-col>
          </b-row>

          <b-row class="mt-2 justify-content-center">
            <!-- <b-col cols="5"></b-col> -->
            <div>
              <b-button
                variant="outline-danger"
                @click="hideToTTrip"
                >Close</b-button
              >
            </div>
            <!-- <b-col cols="3"></b-col> -->
          </b-row>
        </b-modal>
        <!-- Added By Priyanshu SIngh End -->
        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              align="center"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";

export default {
  beforeMount() {
    this.getCurrentLastDate();

    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      // alert(this.$sessionsStorage.get('nameUser'));
      // if((this.$sessionsStorage.get('designation') == 'Admin' && this.$sessionsStorage.get('nameUser') == 'Bhavneesh') || (this.$sessionsStorage.get('designation') == 'Admin' && this.$sessionsStorage.get('nameUser') == 'Aaryav')){
        this.$store.dispatch("setCurrentRoute", "/TPTdashboard");
        // if (globalPermissionStatus("vehicleMaster") != "Disabled") {
        //   this.$sessionsStorage.set(
        //     "PermissionStatus",
        //     globalPermissionStatus("vehicleMaster")
        //   );
        // } else {
        //   this.$router.push({
        //     path: "/dashboard"
        //   });
        // }


        this.viewTypeSize("0", "1", "1");
      // }else{
      //     this.$router.push({
      //       path: "/dashboard"
      //     });
      // }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }

    // lastVisitPage(this.$router.history.current.fullPath);
    // this.$store.dispatch("setCurrentRoute", "/TPTdashboard");
    // if (
    //   this.$sessionsStorage.get("loginId") != undefined &&
    //   this.$sessionsStorage.get("loginId") != "" &&
    //   this.$sessionsStorage.get("departmentName") != undefined &&
    //   this.$sessionsStorage.get("departmentName") != "" &&
    //   this.$sessionsStorage.get("designation") != undefined &&
    //   this.$sessionsStorage.get("designation") != ""
    // ) {
    //   if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
    //     this.fetchLastPage(this.lastVisitPage);
    //   } else {
    //     this.viewTypeSize("0", "1", "1");
    //   }
    // } else {
    //   this.$sessionsStorage.set("loginId", "");
    //   this.$router.push({
    //     path: "/dashboard",
    //   });
    // }
  },

  data() {
    return {
      ExcelBtnName: "Export as Excel",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      clientIdFilter: "",
      assignmentFilter: "",
      clientMaster: [],
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      TripCount: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Vehical_NO",
          mainkey: "Vehical_NO",
          label: "Vehicle No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Vehiclestatus",
          mainkey: "Vehiclestatus",
          label: "Vehicle Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "status",
          mainkey: "status",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "skipGRN",
          mainkey: "skipGRN",
          label: "PDF",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tptType",
          mainkey: "tptType",
          label: "TPT By",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "distance",
          mainkey: "distance",
          label: "Distance",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "tollInCash",
          mainkey: "tollInCash",
          label: "Advance Cash",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "otherCashExpenses",
          mainkey: "otherCashExpenses",
          label: "Actual Diesel Dispensed",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "diesel",
          mainkey: "diesel",
          label: "Diesel",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "dieselPrice",
          mainkey: "dieselPrice",
          label: "Actual Diesel Dispensed",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "totalCost",
          mainkey: "totalCost",
          label: "Toll In Cash",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "cashDeiselPaid",
          mainkey: "cashDeiselPaid",
          label: "Amount Paid in cash for Deisel",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      fields: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "regdNo",
          mainkey: "regdNo",
          label: "Vehical NO",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "isTruckMasterActive",
          mainkey: "isTruckMasterActive",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        // {
        //   key: "engineNo",
        //   mainkey: "engineNo",
        //   label: "Engine No",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },
        // {
        //   key: "chassisNo",
        //   mainkey: "chassisNo",
        //   label: "Chassis No",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },
        // {
        //   key: "modNo",
        //   mainkey: "modNo",
        //   label: "Modal No",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "L.",
        // },
        {
          key: "TripCount",
          mainkey: "TripCount",
          label: "Trip Count",
          sortable: true,
          sortDirection: "ASC",
          table: "L.",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      TotaAvilableVehicle: 0,
      TotaBookedVehicle: 0,
      TotaInactiveVehicle:0,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },

      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      excelUpload: "",
      veiwVehicleMaster: [],
      TripDetails:[],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {
    // this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$router.push({
        path: "/vehicle/truckMaster",
      });
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleMas11").DataTable({
          lengthChange: false,
          width: 100,
          dom: '<"wrapper"iftp>',
        });
      });
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewSubscription(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewTypeSize("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.DateFilter = "";
      this.assignmentFilter = "";
      this.assignmentNo = "assignmentNo";
      this.viewTypeSize("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewTypeSize(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    viewTypeSize(CURRENT, SEARCH, pageNumber) {
      this.doLoading();
      let type_Size = {
        excelId: "",
        DateFilter: this.DateFilter,
        assignmentNo: this.assignmentNo,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        viewDet: "TPTDash",
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getTPTDashDetails.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("MyData=>", data);
            this.veiwVehicleMaster = data.mainTPTDashData;
            this.totalRows = data.mainTPTDashData.length;
            this.TotaAvilableVehicle = data.TotaAvilableVehicle;
            this.TotaBookedVehicle = data.TotaBookedVehicle;
            this.TotaInactiveVehicle = data.TotaInactiveVehicle;
            if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
            }
            this.doLoadingClose();
            this.JqueryFun();
            //console.log("fsf",data.truckSizeDetails)
          }
        })
        .catch((error) => {});
    },
    getReportsAss(id,btnName) {
        let excelIdGivin = "";
        if (id == "TPTDashbord_SCREEN") {
          excelIdGivin = "TPTDashbord_SCREEN";
        } else if (id == "All_TPTDashbord_SCREEN") {
          excelIdGivin = "All_TPTDashbord_SCREEN";
        }
        let view_Assignment = {
          excelId: excelIdGivin,
          DateFilter: this.DateFilter,
          assignmentNo: "assignmentNo",
          searchVal: this.filter,
          fromDate: this.dateSearch.fromDate,
          toDate: this.dateSearch.toDate,
          dateRange: this.dateRange,
        };
        this.ExcelBtnName = "Downloading Please Wait .....";
        
        CommonService.getTPTDashreportsExcel(view_Assignment)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("getTPTDashreportsExcel response: ", response);
            if (status == 200 && data) {
              if (data.excelName) {
                this.ExcelBtnName = btnName;
               
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
                 // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
                  
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getTPTDashreportsExcel Error: ", error);
          });
      },
    // getReportsAss(id) {
    //   this.isLoading = true;
    //   let excelIdGivin = "";
    //   if (id == "TPTDashbord_SCREEN") {
    //     excelIdGivin = "TPTDashbord_SCREEN";
    //   } else if (id == "All_TPTDashbord_SCREEN") {
    //     excelIdGivin = "All_TPTDashbord_SCREEN";
    //   }
    //   let view_Assignment = {
    //     excelId: excelIdGivin,
    //     DateFilter: this.DateFilter,
    //     assignmentNo: "assignmentNo",
    //     searchVal: this.filter,
    //     fromDate: this.dateSearch.fromDate,
    //     toDate: this.dateSearch.toDate,
    //     dateRange: this.dateRange,
    //   };
    //   console.log(view_Assignment);
    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_Common/getTPTDashreportsExcel.php`,
    //     data: JSON.stringify(view_Assignment),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if (status == 200 && data) {
    //         if (data.excelName != undefined) {
    //           window.location.href =
    //             `https://uploadsp.pridel.com/Pridel_Reports/` +
    //             data.excelName;
    //         }
    //         this.isLoading = false;
    //       }
    //     })
    //     .catch((error) => {});
    // },
    showToTTrip(item) {
      this.TripDetails = [];
      this.GetVehicalTripDetails(item);
      this.$refs["Trip-modal"].show();
    },
    hideToTTrip() {
      this.$refs["Trip-modal"].hide();
      this.isLoading = false;
      // this.viewTypeSize("0", "1", "1");
    },
    GetVehicalTripDetails(item) {
      // this.doLoading();
      let TripDetailsdata = {
        excelId: "",
        DateFilter: this.DateFilter,
        searchVal: this.filter,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        viewDet: "ViewTripDet",
        vehicleNo:item.regdNo,
        vehicleTruckId:item.vehicleTruckId,
        salesBookingId:item.salesBookingId,
        allModuleId:item.allModuleId,
        quotatinId:item.quotatinId,
        assignId:item.assignId,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getTripDetails.php`,
        data: JSON.stringify(TripDetailsdata),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("MyTripData=>", data);
            this.TripDetails = data.TripDetails;
            // this.totalRows = data.TripDetails.length;
            // this.doLoadingClose();
            // this.JqueryFun();
            //console.log("fsf",data.truckSizeDetails)
          }
        })
        .catch((error) => {});
    },
    Print(item) {
      item = item.replace("upload_pic/", "");
      console.log(item);
      window.open(`${this.docURL}/` + item);
    },
    DailyVehicleTrack() {
      this.$router.push({
        path: "/tpt/DailyVehicleTrack",
      });
    },
    previousDailyVehicleTrackView() {
      window.history.go(-1);
    },
  },
};
</script>
<style scoped>
body {
  table-layout: fixed !important;
}
</style>


// WEBPACK FOOTER //
// tptDashboard.vue?4ef73afb